import { Reporte } from "../../components/Reporte"

export const ProveedorRep = () => {
    return (
        <Reporte url="ficha/reporte-buscar-proveedor" uindex="ficha/reporte-index-proveedor" nameReport="reporte-proveedor.xlsx" />
    )
}
